if (!customElements.get('bf-footer-video')) {
  customElements.define('bf-footer-video', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.video = this.querySelector('[data-footer-video]');
      this.card = this.querySelector('[data-footer-card]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.near = false;
      this.revealed = false;

      this.observer = new IntersectionObserver(([entry]) => {
        this.near = entry.isIntersecting;
        this.updatePlayback();
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
      this.revealObserver = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting || this.revealed) return;
        this.revealed = true;
        if (!this.reduced.matches && this.card?.animate) {
          this.card.animate([
            { opacity: 0, transform: 'translateY(20px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 500, easing: getComputedStyle(this).getPropertyValue('--bf-ease').trim() || 'ease-out' });
        }
        this.revealObserver.disconnect();
      }, { threshold: 0.1 });
      if (this.card) this.revealObserver.observe(this.card);

      if (!this.video) return;
      this.video.muted = true;
      this.video.addEventListener('playing', () => {
        if (this.reduced.matches || !this.near || document.hidden) {
          this.updatePlayback();
          return;
        }
        this.setAttribute('data-video-ready', '');
      }, { signal });
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-video-ready');
      }, { signal });
      this.reduced.addEventListener('change', () => this.updatePlayback(), { signal });
      this.mobile.addEventListener('change', () => this.updatePlayback(), { signal });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
    }

    updatePlayback() {
      if (!this.video) return;
      const src = this.mobile.matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
      const loadedSrc = this.video.getAttribute('src');
      if (loadedSrc && loadedSrc !== src) {
        this.removeAttribute('data-video-ready');
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.reduced.matches) this.removeAttribute('data-video-ready');
      const shouldPlay = this.near && !document.hidden && !this.reduced.matches;
      if (!shouldPlay) {
        this.video.pause();
        return;
      }
      if (this.video.getAttribute('src') !== src) {
        this.removeAttribute('data-video-ready');
        this.video.src = src;
        this.video.load();
      }
      this.video.play().catch(() => {
        if (this.video.paused) this.removeAttribute('data-video-ready');
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.revealObserver?.disconnect();
      this.video?.pause();
    }
  });
}
